<template>
    <div :class="{index:body_bg}" v-if="body_show">
        <!-- 证书 -->
        <div class="certificate-box clearfix" v-if="report.length>0" >
            <div class="h2">
                共获得 {{data.report_count }} 张证书
            </div>
            <div class="list" v-for="(item,index) in report" :key="index">
                <h3>{{item.course_time}}</h3>
                <div class="group clearfix"  v-for="(ite,inx) in item.list" :key="inx" @click="clickHandle(ite.card_type,ite.card)">
                    <a class="card"><img class="zs" :src="ite.card"></a>
                    <div class="group-text clearfix">
                        <h3 v-if="ite.card_type ==3">恭喜你开启</h3>
                        <h3 v-else>恭喜你完成了</h3>
                        <h2>{{ite.course_name}}</h2>
                        <h4>{{ite.card_name}}</h4>
                    </div>
                    <img v-if="ite.card_type ==3" src="@a/tmz.png" class="bg" />
					<img v-else-if="ite.card_type == 1 || ite.card_type == 2" src="@a/cer_spa.png"  class="bg" />
                </div>
            </div>
        </div>
        <img src="@a/cer_null.png" class="cer_img" v-else/>
        <!-- 引入弹出,判断是小组证书还是投名状-->
        <public-card class="card-box" :imgLink="imgUrl" h4="还可在个人中心查看" :h3="card_type==3?'长按保存，分享公开承诺':'长按上方图片保存分享好友或朋友圈'" ref="card"></public-card>

    </div>
</template>

<script>
import { get_tactic_card } from "@/api/person"
import { shareCon } from "@/utils/wxconfig";
export default {
    data(){
        return{
            body_show:false,
            data:{},
            report:{},
            imgUrl:'',
            card_type:0,
            body_bg:false
        }
    },
    methods:{
        // 初始化获取数据函数
        pullData() {
            get_tactic_card({
                pop_cid: this.$route.query.pop_cid,
				pop_type: this.$route.query.pop_type
            })
            .then(data => {
                this.body_show = true;
                this.data = data;
                this.report = data.report;
                this.body_bg = data.report.length<=0?true:false;
                if(data.pop) {
                    this.clickHandle(data.pop.card_type, data.pop.card);
                }
            });
        },
        // 指定弹出卡片
        clickHandle(type_,url_){
            this.card_type = type_;
            this.imgUrl = url_;
            this.$refs.card.card_show = true;
        }
    },
    created() {
      this.pullData();
      shareCon("index",this);
    }
}
</script>

<style lang="scss" scoped>
    .index{
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background-color: #fff;
        font-size: 0;
    }
    .certificate-box{
        padding-top:40px;
        .h2{
            width:750px;
            height:120px;
            text-align: center;
            font-size: 36px;
            color: #fff;
            line-height: 120px;
            background:linear-gradient(90deg,rgba(245,127,23,1),rgba(235,80,50,1));
        }
        .list{
            padding: 40px 30px 0 30px;
            border-bottom: 1px solid #ccc;
            h3{
                font-size: 34px;
                color: #EB5032;
            }
            .group{
                background-color: #fff;
                margin: 70px 0 40px 0;
                position: relative;
                border-radius: 8px;
                img.zs{
                    width: 158px;
                    margin: -40px 30px 0px 30px;
                    float: left;
                    min-height: 224px;
                }
                .group-text{
                    float: left;
                    color: #333;
                    padding: 30px 0;
                    h3{
                        font-size: 26px;
                    }
                    h2{
                        font-size: 32px;
                        margin-top: 17px;
                        line-height: 1;
                    }
                    h4{
                        color: #F57F17;
                        margin-top: 42px;
                    }
                }
                .bg{
                    position: absolute;
                    width: 172px;
                    bottom: 0;
                    right: 0;
                }
            }
        }
        .list:last-child{
            border-bottom: 0;
        }
    }
    .cer_img{
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translateY(-50%);
        -webkit-transform: translateY(-50%);
        width: 480px;
        margin-left: -240px;
    }

</style>
<style lang="scss">
    .card-box{
        .pop_card{
            img{
                width: 650px;
            }
        }
    }
</style>
